import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogSeparator,
  AlertDialogTitle,
} from '@/components/ui'

type DeleteWorkflowProps = {
  isOpen: boolean
  onClose: () => void
  onConfirm: () => void
}

const DeleteWorkflow = ({
  isOpen,
  onClose,
  onConfirm,
}: DeleteWorkflowProps) => {
  return (
    <AlertDialog open={isOpen} onOpenChange={onClose}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>
            Deseja excluir o o fluxo de trabalho?
          </AlertDialogTitle>
          <AlertDialogDescription>
            Ao excluir o fluxo de trabalho, todos estágios criados serão
            excluídos.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogSeparator />
        <AlertDialogFooter>
          <AlertDialogCancel>Cancelar</AlertDialogCancel>
          <AlertDialogAction onClick={onConfirm}>
            Excluir fluxo de trabalho
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
DeleteWorkflow.displayName = 'DeleteWorkflow'

export { DeleteWorkflow }
